import { SingleMessage, useAppContext } from '@aspendental/shared-components-web';
import { getBffFacilitiesByAddress } from '@aspendental/shared-components-web/lib/services';
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { ContentItem } from '../ComponentResolver/ComponentResolver';
import { getSchedulingPageLeftImageStyles, getSchedulingPageStepperWrapperStyles, getSchedulingPageWrapperStyles } from './SchedulingPage.styles';
import { Stepper } from './Stepper/Stepper';
import NewOrReturningGuest from './Steps/NewOrReturningGuest/NewOrReturningGuest';
import { PersonalInformationStep } from './Steps/PersonalInformationStep/PersonalInformationStep';
import { TimeSlotsStep } from './Steps/TimeSlotsStep/TimeSlotsStep';
import ComponentResolver from '@src/components/ComponentResolver';
import { LocationsAndServices } from '@src/components/scheduling/Steps/locationAndServices/LocationsAndServices';
import { Maybe, SingleMessage as TSingleMessage } from '@src/lib/__generated/sdk';
import { BffBrandType } from '@src/lib/types';
import { useAppStore, useSchedulingStore } from '@src/store';
import { pushToDataLayer } from '@src/utils/pushToDataLayer';
import { BffFacility } from 'types/location';
interface IBottomContentCollection {
  items: ContentItem[];
}
interface ISchedulingPageProps {
  featuredContent?: Maybe<TSingleMessage>;
  bottomContentCollection?: Maybe<IBottomContentCollection>;
}
export const SchedulingPage = ({
  featuredContent,
  bottomContentCollection
}: ISchedulingPageProps) => {
  const theme = useTheme();
  const isLessThanMD = useMediaQuery(theme.breakpoints.down('md'));
  const isLessThanSM = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    currentStepIndex,
    changeCurrentStepIndex
  } = useSchedulingStore(state => state);
  const {
    featureFlags
  } = useAppStore();
  const {
    setBffFacilities
  } = useSchedulingStore(state => state);
  const {
    environment,
    config,
    appName,
    appVersion
  } = useAppContext();
  const url = environment === 'prod' ? config.services.prod.BEFFE_GRAPHQL_URL : config.services.nonprod.BEFFE_GRAPHQL_URL;

  // initiate the page with a beffe location search using a location beyond 200 miles from any location
  // add response to the store
  useEffect(() => {
    if (featureFlags.useFacilityBeffeDataSource) {
      const fetchBffFacilityData = async () => {
        const list = await getBffFacilitiesByAddress('CHAPTER' as BffBrandType, 'hawaii', url, true, appName, appVersion);
        setBffFacilities(list?.facilitiesByAddress as BffFacility[]);
      };
      fetchBffFacilityData();
      pushToDataLayer({
        event: 'appointment_step',
        stepName: 'start_of_appointment'
      });
    }
  }, []);
  return <>
			<Box sx={getSchedulingPageWrapperStyles(isLessThanMD)} data-sentry-element="Box" data-sentry-source-file="SchedulingPage.tsx">
				<Box sx={getSchedulingPageLeftImageStyles(isLessThanMD)} data-sentry-element="Box" data-sentry-source-file="SchedulingPage.tsx">
					{featuredContent && <SingleMessage {...featuredContent} linkedFrom={null} />}
				</Box>

				<Box sx={getSchedulingPageStepperWrapperStyles(isLessThanMD, isLessThanSM)} data-sentry-element="Box" data-sentry-source-file="SchedulingPage.tsx">
					<Stepper selectedIndex={currentStepIndex} onStepTitleClick={changeCurrentStepIndex} steps={[{
          title: 'Are you a returning guest?',
          component: <NewOrReturningGuest />
        }, {
          title: 'Select a location & treatment.',
          component: <LocationsAndServices index={1} />
        }, {
          title: 'When works for you?',
          component: <TimeSlotsStep index={2} />
        }, {
          title: "Let's confirm a few details.",
          component: <PersonalInformationStep index={3} />
        }]} data-sentry-element="Stepper" data-sentry-source-file="SchedulingPage.tsx" />
				</Box>
			</Box>

			<Stack spacing={2} data-sentry-element="Stack" data-sentry-source-file="SchedulingPage.tsx">
				{bottomContentCollection?.items && bottomContentCollection?.items?.map((contentItem, index) => <ComponentResolver key={index} contentItem={contentItem ?? {}} />)}
			</Stack>
		</>;
};